var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8131_5900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2 20.6C41.2 36.05 20.6 51.5 20.6 51.5C20.6 51.5 0 36.05 0 20.6C0 15.1365 2.17035 9.89685 6.0336 6.0336C9.89685 2.17035 15.1365 0 20.6 0C26.0635 0 31.3032 2.17035 35.1664 6.0336C39.0297 9.89685 41.2 15.1365 41.2 20.6Z",
    fill: "#F49D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 28.325C24.8664 28.325 28.325 24.8664 28.325 20.6C28.325 16.3336 24.8664 12.875 20.6 12.875C16.3336 12.875 12.875 16.3336 12.875 20.6C12.875 24.8664 16.3336 28.325 20.6 28.325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8131_5900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.2,
    height: 51.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.23f8577bf1ae174c718f40943f91e1d6.svg";
export { ForwardRef as ReactComponent };